module.exports = __webpack_public_path__ + "static/media/file-document-paper-svgrepo-com.81f75257.svg";